export const Historic1FinancialOptions = [
  {
    label:'Claim Id',
    type:'text',
    recordName: 'Claim_ID'
  },
  {
    label:'Charge Code',
    type:'text',
    recordName: 'Charge_code'
  },
  {
    label:'Status',
    type:'text',
    recordName: 'Status'
  },
  {
    label:'Charged',
    type:'dollar',
    recordName: 'Charged'
  },
  {
    label:'Paid',
    type:'dollar',
    recordName: 'Paid'
  },
  {
    label:'Balance',
    type:'dollar',
    recordName: 'Balance'
  },
  {
    label:'Payout &',
    type:'dollar',
    recordName: 'Charged'
  },
  {
    label:'Date',
    type:'date',
    recordName: 'Date'
  },
]